<template>
  <div :class="bem.b()">
    <canvas ref="canvasRef" class="barcode-canvas" />
  </div>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
// import { useAttrs } from 'vue'
import { barcodeProps } from './barcode'

// 1.defineOptions
defineOptions({
  name: 'LlBarcode',
})
// 定义组件props
const props = defineProps(barcodeProps)

const bem = createNamespace('barcode')

import JsBarcode from 'jsbarcode'
import { nextTick, onMounted, ref, watch } from 'vue'

const canvasRef = ref<HTMLCanvasElement | null>(null)
const generateBarcode = () => {
  // 如果值无效则不生成
  if (!props.value || !canvasRef.value) return

  try {
    const options = {
      format: props.format,
      width: props.width,
      height: props.height,
      displayValue: props.displayValue,
      textAlign: props.textAlign,
      textPosition: props.textPosition,
      textMargin: props.textMargin,
      fontSize: props.fontSize,
      background: props.background || '#ffffff',
      lineColor: props.lineColor || '#000000',
      margin: props.margin,
      flat: props.format === 'ITF14' ? undefined : false,
    }

    JsBarcode(canvasRef.value, props.value, options)
  } catch (error) {
    console.error('条形码生成失败:', error)
  }
}

// 监听所有props变化（深度监听）
watch(
  () => Object.values(props),
  () => {
    // 在下一个DOM更新周期更新条形码
    nextTick(generateBarcode)
  },
  { deep: true }
)

onMounted(() => {
  generateBarcode()
})
</script>
